module.exports = __webpack_public_path__ + "img/generator.dd238d96.png";